import Image from 'next/image';
import React, { FC, SVGProps } from 'react';
import Button from '~/components/button';
import WYSIWYGContent from '~/components/wysiwyg-content';
import alt from '~/utils/default-alt';

import styles from './styles.module.css';

interface Props {
  description: string;
  title: string;
  errorBackground?: string;
  errorAlt: string;
  ErrorIcon: FC<SVGProps<SVGElement>>;
}

const ErrorBody: React.FC<Props> = ({ description, title, errorAlt, errorBackground, ErrorIcon }) => {
  return (
    <main className={styles.container}>
      <div className={styles.content}>
        <p className={styles.error}>{title}</p>
        <ErrorIcon className={styles.icon} />
        <WYSIWYGContent className={styles.description} html={description} />
        <Button className={styles.btn} href="/" title="На главную" />
      </div>
      {errorBackground && (
        <div className={styles.imageContainer}>
          <Image className={styles.image} src={errorBackground} alt={alt(errorAlt)} />
        </div>
      )}
    </main>
  );
};

export default ErrorBody;
